import { client } from "@lib/api"
import useSWR from "swr"

type OngoingTransactionInformation = {
    hasOngoingTransaction: boolean
    canCreateNewTransaction: boolean
}

const useOngoingTransaction = () => {
    const { data, isLoading, error, isValidating } = useSWR(
        '/wallet/ongoing-transaction', 
        client.doGet,
        {
            revalidateIfStale: true,
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
            revalidateOnMount: true,
            refreshWhenHidden: true,
            refreshWhenOffline: true,
        }
    )
    return {
        data: data as OngoingTransactionInformation | undefined,
        isLoading: isLoading || isValidating,
        error
    }
}

export default useOngoingTransaction
